<template>
    <div class="d-flex flex-columns">
        <v-select
            class="banner-select"
            dense
            outlined
            multiple
            chips
            deletable-chips
            small-chips
            :items="items"
            :menu-props="{ contentClass: 'banner-select-menu' }"
            :placeholder="$t('choose_multi')"
            :item-text="itemText"
            :item-value="itemValue"
            :value="value"
            v-on="$listeners"
            v-bind="$attrs"
        >
        </v-select>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { TYPE } from '@/models/Banner';

export default {
    name: 'BannerReductionSelect',

    props: {
        value: {
            type: Array,
            default: () => [],
        },
        itemText: {
            type: String,
            default: 'title'
         },
        itemValue: {
            type: String,
            default: 'id'
        },
    },

    computed: {
        ...mapState('banner', {
            loaded: 'loaded',
            collection: 'collection',
        }),
        items() {
            if (this.collection) {
                return this.collection.filter((item) => item.type === TYPE.reduction.title_key).models;
            }
            return [];
        },
    },

    mounted() {
        this.loadData();
    },

    methods: {
        ...mapActions('banner', {
            loadData: 'load',
        }),
        reload() {
            this.loadData({ force: true });
        },
    },
};
</script>

<style lang="scss">
.banner-select-menu {
    .v-list-item {
        min-height: 25px !important;

        .v-list-item__content {
            padding: 0 !important;
        }
    }
}
</style>
